///<reference path="../require.d.ts"/>

import {parse} from "qs";
import {Room} from "../models/Room";
import {SearchResult} from "../models/SearchResult";
import {CheckedRoomRepository} from "../services/CheckedRoomRepository";
import {Station} from "../models/Room";

class RoomsPageController {

    static $inject = ["$element", "$http", 'CheckedRoomRepository'];

    result: SearchResult<Room>;

    get rooms(): Room[] {
        return this.result.items;
    }

    constructor(
        private $element: angular.IAugmentedJQuery,
        private $http: angular.IHttpService,
        private checked: CheckedRoomRepository
    ) {
        const query = jQuery.param(this.params());
        $http.get<SearchResult<Room>>(`${apiRoot}/rooms?${query}`).success((result) => {
            this.result = result;
            this.updateChecked();
        });
    }

    isChecked(id: number): boolean {
        return this.checked.isChecked(id);
    }

    toggle(id: number): void {
        this.checked.toggle(id);
        this.updateChecked();
    }

    updateChecked(): void {
        const ids = this.checked.load();
        this.rooms.forEach((r: Room) => {
            r.checked = this.checked.isChecked(r.id, ids);
        });
    }

    walk(a: Station): string {
        if (!!a.walk_minutes) {
            return `${a.walk_minutes}分`;
        } else {
            return a.transport as string;
        }
    }

    builtOnYears(src: any): string {
        if (!src) return ' - ';
        const date = moment(src).toDate();
        const now = new Date();
        const diff = now.getFullYear() - date.getFullYear();
        return `築${diff}年`;
    }

    pages(): number[] {
        const first = Math.max(1, this.result.current_page - 2);
        const last = Math.min(this.result.total_pages, this.result.current_page + 2);
        const result: number[] = [];
        for (let i = first; i <= last; i++) {
            result.push(i);
        }
        return result;
    }

    pagerUrl(page: number): string {
        const url = this.url();
        if (page === 1) {
            return url;
        } else {
            const sep = /\?/.test(url) ? '&' : '?';
            return `${url}${sep}page=${page}`;
        }
    }

    url(): string {
        // MHP-67 page が null で渡される場合がある。再現条件は不明。
        return location.href.replace(/(&|\?)?page=(\d+|null)/, '');
    }

    private params(): any {
        const result: any = parse(location.search.substr(1));
        const cm = /\/cities\/(\d+)(\.html)?$/.exec(location.pathname);
        const sm = /\/stations\/(\d+)(\.html)?$/.exec(location.pathname);
        if (cm) {
            result.city_id = cm[1];
        } else if (sm) {
            result.station_group_id = sm[1];
            const lm = /line_id=(\d+)/.exec(location.search);
            if (lm) result.line_id = lm[1];
        }
        return result;
    }

}

angular.module('hp').controller('RoomsPageController', RoomsPageController);



// WEBPACK FOOTER //
// ./controllers/RoomsPageController.ts